import React, { useEffect, useState } from "react";

const LoadingScreen = ({ onFinished }) => {
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFinished(true);
      if (onFinished) setTimeout(onFinished, 800);
    }, 2400);
    return () => clearTimeout(timer);
  }, [onFinished]);

  return (
    <div className={`loading-overlay ${isFinished ? "fade-out" : ""}`}>
      <div className="logo-animation-container">
        <svg viewBox="0 0 800 400" className="svg-logo">
          <g className="text-container">
            <text x="50%" y="200" textAnchor="middle" className="text-mnt">
              MNT
            </text>

            <text x="50%" y="280" textAnchor="middle" className="text-podsused">
              PODSUSED
            </text>
          </g>
        </svg>
      </div>
    </div>
  );
};

export default LoadingScreen;
